import Vue from 'vue';
import Axios from 'axios';
import Errors from '../classes/Errors';
import store from '../store';

Vue.component('submit-form', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            success: false,
            submitting: false,
            client: store.client
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

        onSubmit(event) {
            this.submitting = true;
            this.errors.clear();

            this.client.answers = store.answers;

            Axios
                .post(event.currentTarget.action, this.client)
                .then(response => {
                    this.submitting = false;
                    this.handleSuccess();
                })
                .catch(error => {
                    this.handleErrors(error.response.data);
                });
        },

        handleSuccess() {
            this.$root.showThankYou = true;
        },

        handleErrors(data) {
            this.errors.record(data.errors);
        }
    }
});
